module.exports = __webpack_public_path__ + "static/img/osde-2.ce8f696.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/osde-2.jpg
// module id = rzOJ
// module chunks = 1